// Border radius system — Plaud-minimal grammar
// Buttons and inputs are pill (`full`) or 12; cards sit at 12–16; sheets 22.

export const BORDER_RADIUS = {
  xs: 4, // Micro rounding (small badges)
  sm: 6, // Subtle rounding (tags, small elements)
  md: 12, // Standard rounding (inputs, media, small cards)
  lg: 14, // Cards
  xl: 16, // Large cards, modals
  xxl: 22, // Bottom sheets, special containers
  full: 9999, // Pills, avatars, circular elements
} as const;

export type BorderRadiusKey = keyof typeof BORDER_RADIUS;
export type BorderRadiusValue = (typeof BORDER_RADIUS)[BorderRadiusKey];
